import Vue from "vue";
import axios from "axios";
import { eventBus } from "../../events/event-bus";

import { FileUploader } from "../file-uploader";
import { sendGenericErrorMessage } from "../../utilities/send-generic-error-message";

const state = {
  current3DFile: "",
  printFilesById: {},
  printFileIds: [],
};

const mutations = {
  SET_3D_FILES(state, printFiles) {
    state.printFilesById = printFiles;
  },
  SET_3D_FILE_BY_ID(state, printFile) {
    if (!printFile.id) return;
    Vue.set(state.printFilesById, printFile.id, printFile);
    if (state.printFileIds.includes(printFile.id)) return;
    state.printFileIds.push(printFile.id);
  },
  SET_CURRENT_3D_FILE(state, printFile) {
    if (!printFile.id) return;
    if (!state.printFileIds.includes(printFile.id)) {
      Vue.set(state.printFilesById, printFile.id, printFile);
      state.printFileIds.push(printFile.id);
    }
    state.current3DFile = printFile.id;
  },
  SET_HISTOGRAM_VISUALIZATION_URL(state, url) {
    state.histogramVisualizationURL = url;
  },
};

const API_URL = process.env.VUE_APP_FULFILLMENT_API_BASE_URL;

const actions = {
  upload3DFile: async ({ commit, state, dispatch }, { file }) => {
    let fileUploader = new FileUploader({ uploadURL: API_URL });
    let analysisResults = await fileUploader.uploadFile({
      file,
      uploadUrl: API_URL,
    });
    commit("SET_CURRENT_3D_FILE", analysisResults);
    commit("SET_CURRENT_CART_ITEM", { objectId: analysisResults.id });
  },
  useDemoObject: async ({ commit }) => {
    let analysisResults = (
      await axios.get(
        `${API_URL}/analytx/file/24f4915d-a95f-4f88-82a4-44f2bf711723`
      )
    ).data;

    commit("SET_CURRENT_3D_FILE", analysisResults);
    commit("SET_CURRENT_CART_ITEM", { objectId: analysisResults.id });
  },
  update3DFile: async ({ commit, state }, data) => {
    if (state.printFileIds.includes(data.id)) {
      commit("SET_3D_FILE_BY_ID", {
        ...state.printFilesById[data.id],
        ...data,
      });
    }
    if (data.givenUnitOfLength) {
      eventBus.cartItemPricingInvalid();
    }
  },
  persist3DFile: async ({ commit, state }, id) => {
    if (state.printFileIds.includes(id)) {
      let file = state.printFilesById[id];

      const response = await axios.patch(`${API_URL}/analytx/file/${id}`, {
        name: file.name,
        givenUnitOfLength: file.givenUnitOfLength,
      });

      commit("SET_3D_FILE_BY_ID", response.data);
    }
  },
  fetchPrintFileById: async ({ commit, state, dispatch }, id) => {
    try {
      const response = await axios.get(`${API_URL}/analytx/file/${id}`);
      commit("SET_3D_FILE_BY_ID", response.data);
      return response.data;
    } catch {
      sendGenericErrorMessage();
    }
  },
};

const getters = {
  printFiles: (state, rootGetters) => {
    return state.printFileIds.map((id) => {
      return rootGetters.printFileById(id);
    });
  },
  printFileById: (state) => (printFileId) => {
    return state.printFilesById[printFileId];
  },
  current3DFile: (state) => {
    return state.printFilesById[state.current3DFile];
  },
};

export default { state, mutations, actions, getters };
